import React, { useRef, useState, useEffect } from 'react';
import { useCurrency } from '../contexts/CurrencyContext';
import { ChevronDown } from 'lucide-react';

const NavCurrencySwitcher = () => {
    const { currency, setCurrency, currencies } = useCurrency();
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    const currentInfo = currencies[currency] || currencies['GHS'];
    const currencyList = Object.values(currencies);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    if (!currentInfo) return null;

    return (
        <div className="relative inline-block text-left" ref={menuRef}>
            <button
                type="button"
                className="flex items-center gap-1 px-2 py-1 text-sm font-medium text-gray-700 hover:text-blue-600 focus:outline-none transition-colors rounded-md hover:bg-gray-50 bg-white border border-gray-200"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="text-lg leading-none">{currentInfo.flagEmoji}</span>
                <span className="hidden sm:inline">{currentInfo.code}</span>
                <ChevronDown className="w-4 h-4 text-gray-400" />
            </button>

            {isOpen && (
                <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                    <div className="py-1 max-h-60 overflow-y-auto">
                        {currencyList.map((curr) => (
                            <button
                                key={curr.code}
                                onClick={() => {
                                    setCurrency(curr.code);
                                    setIsOpen(false);
                                }}
                                className={`flex items-center w-full text-left px-4 py-2 text-sm £{currency === curr.code ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'}`}
                            >
                                <span className="text-lg mr-2 leading-none">{curr.flagEmoji}</span>
                                <span>{curr.code}</span>
                                <span className="ml-auto text-xs text-gray-400">{curr.symbol}</span>
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default NavCurrencySwitcher;
